import * as ENDPOINTS from '@/common/constants/endpoints'
import { shouldInsertAccount } from '@/utils/account'

import { api } from '../api'

export const getVariableIncome = async ({ account, accountType }: DefaultHeader) =>
  api<VariableIncome>(ENDPOINTS.VARIABLE_INCOME, {
    method: 'GET',
    headers: {
      'account-type': accountType,
      ...shouldInsertAccount({ accountType, account }),
    },
  })
